<template>
  <div>
    <div class="modal" v-bind:class="{'is-active':isActive}">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Edit Goal</p>
          <button class="delete" aria-label="close" @click="close"></button>
        </header>
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <h1 class="title">Game Info</h1>
              <div class="field">
                <label class="label">Game Time</label>
                <div class="control">
                    <input type="text" class="input">
                </div>
              </div>
              <div class="field">
                <label class="label">Period</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="period" name="period" class="" v-model="goalData.period" required>
                            <option v-for="option in periodOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Situation</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="situation" name="situation" class="" v-model="goalData.situation" required>
                            <option v-for="option in situationOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
            </div>
            <div class="column">
              <h1 class="title">Goal Details</h1>
              <div class="field">
                <label class="label">Goal Scorer</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="goal_scorer" name="goal_scorer" class="" v-model="goalData.goal_scorer" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">First Assist</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="first_assist" name="first_assist" class="" v-model="goalData.first_assist" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Second Assist</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="second_assist" name="second_assist" class="" v-model="goalData.second_assist" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
            </div>
            <div class="column">
              <h1 class="title"> On Ice +/-</h1>
              <div class="field">
                <label class="label">Player 1</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_1" name="on_ice_1" v-model="goalData.on_ice_1" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Player 2</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_2" name="on_ice_2" v-model="goalData.on_ice_2" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Player 3</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_3" name="on_ice_3" v-model="goalData.on_ice_3" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Player 4</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_4" name="on_ice_4" v-model="goalData.on_ice_4" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Player 5</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_5" name="on_ice_5" v-model="goalData.on_ice_5" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>
              <div class="field">
                <label class="label">Player 6</label>
                <div class="control">
                    <div class="select is-small">
                        <select  id="on_ice_6" name="on_ice_6" v-model="goalData.on_ice_6" required>
                            <option v-for="option in AllPlayerOptions" v-bind:value="option.value" v-bind:key="option.value">{{option.text}}</option>
                        </select>
                    </div>
                </div>
              </div>

            </div>
        </div>
        
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="save">Save</button>
          <button class="button" @click="close">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Notification from 'vue-bulma-notification'
const NotificationComponent = Vue.extend(Notification)
const openNotification = (propsData = {
  title: '',
  message: '',
  type: '',
  direction: '',
  duration: 4500,
  container: '.notifications'
}) => {
  return new NotificationComponent({
    el: document.createElement('div'),
    propsData
  })
}
export default {
  components: {
    Notification
  },
  data () {
    return {
      goalData: {
        'team_id': 0,
        'goal_scorer': 0,
        'first_assist': 0,
        'second_assist': 0,
        'game_id': 1,
        'period': 0,
        'situation': 0,
        'on_ice_1': 0,
        'on_ice_2': 0,
        'on_ice_3': 0,
        'on_ice_4': 0,
        'on_ice_5': 0,
        'on_ice_6': 0
      }
    }
  },
  methods: {
    launch: function () {
      this.isActive = true
    },
    close: function () {
      this.isActive = false
    },
    save: function () {
      console.log(this.formData)
      let post = new FormData() // eslint-disable-line no-undef
      this.formData.team_id = this.$route.params.teamId
      post.append('player', JSON.stringify(this.formData))
      this.$http.post('https://devilsapi.roblutken.com/api/players/update/' + this.$route.params.teamId + '/' + this.formData.id, post, { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          console.log(response)
          if (response.data.status === '202') {
            openNotification({
              title: 'Update Success',
              message: response.data.message,
              type: 'success',
              duration: 3400
            })
            this.$router.push('/editors/player-editor/' + this.$route.params.teamId)
          } else {
            openNotification({
              title: 'Failed to update',
              message: response.data.message + response.data.status,
              type: 'danger',
              duration: 3400
            })
          }
          this.close()
          console.log('dataUpdate')
          this.$emit('dataUpdate', 'test')
        }
      )
    },
    openNotificationWithType (type) {
      openNotification({
        title: 'This is a title',
        message: 'This is the message.',
        type: type
      })
    }
  }
}
</script>

<style>
.modal-card{
  position:absolute;
  display:initial;
  top:10em;
}
textarea,
.textarea {
  min-height: 150px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// edit-goal-dialog.vue?7c7c02e5